import ChatBox from "@/components/ChatBox";
import { WILDER_AVATAR } from "@/lib/api";
import { Link } from "react-router-dom";

export default function WilderPage() {
  return (
    <div data-testid="wilder-page">
      <section className="border-b border-[#2A2A2A]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img src={WILDER_AVATAR} alt="Wilder" className="wilder-float w-36 h-36 object-cover rounded-full border-2 border-[#D4AF37] mb-8" />
            <p className="text-xs uppercase tracking-[0.25em] text-[#E4BD44] mb-4">Chi è Wilder</p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight mb-6">
              Il genio folle<br />uscito dai quadri
            </h1>
            <p className="text-sm text-[#C9C4B8] leading-relaxed mb-6">
              Wilder è un "figlio d'arte" in senso letterale: nato dalle tele di Italo Blandolino, dipinto in watercolor e olio,
              è curioso, visionario, alchimista tra arte e cucina — ironico ma poetico.
            </p>
            <p className="text-sm text-[#C9C4B8] leading-relaxed mb-8">
              Chiedigli una ricetta ispirata a un'opera, un consiglio per il tuo locale, o come usare l'AI da creator.
              Ti indirizzerà lui, tra corsi, eventi e servizi. In arrivo: serie, contenuti e i corsi con Wilder.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link to="/assaggi-darte" className="btn-outline">Assaggi d'Arte</Link>
              <Link to="/corsi" className="btn-outline">Corsi in arrivo</Link>
            </div>
          </div>
          <div className="lg:col-span-7">
            <ChatBox />
            <p className="text-xs text-[#9a9484] mt-3">
              Wilder è un'AI (Claude Sonnet 4.5) con la personalità del genio folle. Le risposte sono generate: prendile con un pizzico di polvere d'oro.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
